import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data:[]
    },

}
//types
const OBTENER_CATALOGO_MAGUEY_EXITO= 'OBTENER_CATALOGO_MAGUEY_EXITO'
const AGREGAR_CATALOGO_MAGUEY_EXITO= 'AGREGAR_CATALOGO_MAGUEY_EXITO'

const ACTUALIZAR_CATALOGO_MAGUEY_EXITO= 'ACTUALIZAR_CATALOGO_MAGUEY_EXITO'


export const obtenerCatalogoMaguey = createAsyncThunk(
    OBTENER_CATALOGO_MAGUEY_EXITO,
    async () => {
        try {
            const fullUrl = host + `CatalogoMaguey/obtenerCatalogoMaguey`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarNuevoMaguey = createAsyncThunk(
    AGREGAR_CATALOGO_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `CatalogoMaguey/agregarNuevoMaguey`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarMaguey = createAsyncThunk(
    ACTUALIZAR_CATALOGO_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `CatalogoMaguey/actualizarMaguey`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const catMagueySlice = createSlice({
    name: 'catMagueySlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [obtenerCatalogoMaguey.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [agregarNuevoMaguey.fulfilled]: (state, { payload }) => {
         
        },

        [actualizarMaguey.fulfilled]: (state, { payload }) => {
       
        },
    },
})

export const {
    
} = catMagueySlice.actions
export const CatalogoMagueyReducerUsuarioAgricola = catMagueySlice.reducer
